<template>
     <el-dialog title="财务批注提醒" :visible.sync="pageShow" :width="'400px'" @close="close">
          <div class="comment">
               <div class="list" v-for="(item, index) in dataList" :key="index">{{ item }}</div>
          </div>
          <span slot="footer" class="dialog-footer">
               <el-button type="primary" @click="save">确 定</el-button>
          </span>
     </el-dialog>
</template>

<script>
export default {
     data() {
          return {
               pageShow: false,
               dataList: []
          }
     },
     methods: {
          open(option) {
               this.pageShow = true;
               this.dataList = option.list;
          },
          close() {
               console.log('close')
               this.$emit('ok');
               this.pageShow = false;
          },
          save() {
               this.$emit('ok');
               this.pageShow = false;
          }
     },
}
</script>

<style lang="less" scoped>
     .comment{
          padding: 5px 0;
          .list{ font-size:13px; padding: 4px 0 4px 12px; position: relative;
               &::after{content: ""; display: block; width: 5px; height: 5px; border-radius: 50%; background-color: #333; position: absolute; left: 0; top: 10px; }
          }
     }
</style>